import { Injectable } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  isLoadingEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  public loadingQueue: String[] = [];

  constructor() { }

  enqueueLoad(fName: string){
      this.loadingQueue.push(fName);
      this.isLoadingEmitter.emit(true);
  }

  dequeueLoad(fName: string){
     
        let i = this.loadingQueue.findIndex(load => load == fName);
        if(i > -1){
          this.loadingQueue.splice(i, 1);
        }
  
        if(this.loadingQueue.length == 0){
            this.isLoadingEmitter.emit(false);
        }
  }

}